<template>
  <div class="bg-white p-8">
    <div v-if="isEmpty(supplyOrders)">Não existem artigos no carrinho...</div>
    <div
      class="mb-12"
      v-for="order in supplyOrders"
      v-else
    >
      <div class="flex justify-between">
        <h3 class="text-grey-darkest flex mb-3">{{order.supplier.name}}
          <button
            @click="deleteSupplyOrder(+order.id)"
            class="flex ml-3"
          >
            <icon
              name="trash-2"
              class="w-4 text-grey hover:text-red-dark self-center"
            />
          </button>
        </h3>
        <router-link
          :to="`/supply-orders/${order.id}/edit`"
          class="self-center text-sm text-blue hover:text-blue-dark tracking-wide flex"
        >
          Ver
        </router-link>
      </div>
      <CartProduct :supplyOrderId="order.id"></CartProduct>
    </div>
  </div>
</template>

<script>
import { isEmpty } from "lodash";
import gql from "graphql-tag";
import CartProduct from "./CartProduct.vue";
import { computed } from "@vue/composition-api";
export default {
  props: [
    "supplyOrders",
    "removeProduct",
    "deleteSupplyOrder",
    "updateQuantity"
  ],
  components: {
    CartProduct
  },
  setup(props, ctx) {
    return { isEmpty };
  }
};
</script>


// WEBPACK FOOTER //
// CartProductList.vue?e85e5768